import React, {Component} from 'react';
import NavListAccordion, {NavListAccordionWrapper} from '../../../common/NavListAccordion/NavListAccordion';
import {Translations, convertStringToArrayForOption} from '../../../../utils';
import {eapiClient, aemHostClient} from '../../../../restClient';
import {setLandingActiveTab} from '../../../CaseBody/actions/actionCreator';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import BasicDetail from './BasicDetail';
import SweepInstruction from './SweepInstruction'
import AccountInterestLimit from './AccountInterestLimit'
import SweepGroupLimit from './SweepGroupLimit';
import SweepExecution from './SweepExecution';
import EchannelReporting from './EchannelReporting';

import './CCPreview.css'

// Main Section
class PreviewCashCon extends Component{
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.data !== undefined ? this.props.data : {},
      metaData: {},
      title: false,
      originalData:this.props.echannels !== undefined ? this.props.echannels : undefined
    };
  }

  translations = (word) => {
    var currentWord = Translations(word,this.props.lang.currentLang.lang, this.props.lang.translatedData)
    return currentWord;
  }

  translateWordForOption = (word) => {
    var currentWord = Translations(word,this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArrayForOption(currentWord);
    return convertedArray;
  }

  componentWillMount(){

    aemHostClient("/aemData/formData/json_preview-sweep-gls-for-all-page")
    .then(({data, status}) => {
      this.setState({
        allPageJson:data.par
      })
    });


    if(this.props.match !== undefined){
      var {caseId} = this.props.match.params;
      eapiClient(`/product/gls/${caseId}/preview-request`, {method: 'GET'})
      .then(({data}) => {
        // gls
        this.setState({
          data: data.responseData,
          title: true
        })
        this.state.originalData === undefined && eapiClient(`/cases/${data.responseData.caseId}/previewRequest`, {method: 'GET'})
        .then(({data, status}) => {

           this.setState({
             originalData : data.responseData.productDetails.eChannels !== undefined &&  data.responseData.productDetails.eChannels.length > 0 ?  data.responseData.productDetails.eChannels : []
           });
          });
      });
    }


    aemHostClient("/aemData/formData/json_preview-cash-concentration")
    .then(({data, status}) => {
      let heading='Cash Concentration';
      document.title =`${ heading} - ${'HSBC GLCM'}`;
      this.setState({
        metaData: data.par
      })
      //this.props.setDarkTitleBarContent(heading, true, Translations(data.par.static_text_darkTitleBar.exitCase,this.props.lang.currentLang.lang, this.props.lang.translatedData), "icon icon-delete", currentCase);
    });

    aemHostClient("/aemData/formData/json_dark-title-bar")
    .then(({data, status}) => {
      //this.props.setDarkTitleBarContent(heading, true, Translations(data.par.static_text_darkTitleBar.exitCase,this.props.lang.currentLang.lang, this.props.lang.translatedData), "icon icon-delete", currentCase);
    });

    aemHostClient("/aemData/formData/json_preview-request-open")
    .then(({data, status}) => {
      this.setState({
        pageJson:data.par
      })
    });
  }

  eventToGoCase = () => {
    this.props.setLandingActiveTab(1);
    this.props.history.push('/case-list');
  }

  getCountryTaxonomy=(item)=>{
    if(this.props.countryList !== undefined){
              this.props.countryList.filter(countItem => {
                if ('country' in item) {
                  if (countItem.id === item.country.value) {
                    item.country.name = countItem.name
                    }
                  }else{
                    if (countItem.id === item.value) {
                      item.name = countItem.name
                      }
                  }
                })
                return item;
              }
      }

      getProductRelatedTaxonomy(product){
        if (product !== undefined) {
           this.props.accountCountryList.filter(countItem => {
              if ('country' in product) {
                if (countItem.id === product.country.value) {
                  product.country.name = countItem.name
                    if(product.accountType !== undefined){
                      countItem.associations.filter(accountType =>
                      {
                      if(accountType.id === product.accountType.value){
                        product.accountType.name = accountType.name
                          }
                      })
                  }} }
            });
            return product;
    }
    }

  render(){
    const tabTitleHtml = (
      <div className="ie-navigation">
         <div className="title">
            {
              this.state.metaData !== undefined && this.state.metaData.staticText_previewData !== undefined
              ? `${this.translations(this.state.metaData.staticText_previewData.title)} >`
              : `Cash Concentration  > `
            }
         </div>
         <span>{`${this.state.data !== undefined && this.state.data.glsAgent !== undefined ? this.state.data.glsAgent.name : ''}`}</span>
       </div>
     );

      if(this.state.data !== undefined){
        return(
          <div className="cc-preview-request-container">
            <div className="gdoc-preview-request-content">
              {
                this.state.title && this.state.metaData !== undefined && this.state.metaData.staticText_previewData !== undefined &&
                <div className="gdoc-preview-request-preview-request border-bottom-none">
                  <span>{this.translations(this.state.metaData.staticText_previewData.title)}</span>
                </div>
              }
              <div className="cc-container">
                <NavListAccordionWrapper>
                  <NavListAccordion
                    navAccHeading={tabTitleHtml}
                  >
                    {
                        this.state.allPageJson !== undefined && this.state.allPageJson.staticText_basicDetailsPanel !== undefined
                        ? <BasicDetail
                            data={this.state.data}
                            pageJson={this.state.allPageJson.staticText_basicDetailsPanel}
                            translations={(word) => this.translations(word)}
                            countryList= {this.props.countryList}
                            getCountryTaxonomy={(item) => this.getCountryTaxonomy(item)}
                          />
                        : ''
                    }
                    <hr/>
                    {
                      this.state.allPageJson !== undefined
                      ?   <SweepInstruction
                          data={this.state.data}
                          pageJson={this.state.allPageJson}
                          translations={(word) => this.translations(word)}
                          translateWordForOption={(word) => this.translateWordForOption(word)}
                          accountCountryList= {this.props.accountCountryList}
                          getCountryTaxonomy={(item) => this.getProductRelatedTaxonomy(item)}
                        />
                      : ''
                    }
                    <hr/>
                    {
                      this.state.allPageJson !== undefined &&  this.state.data.cashConcentration !== undefined && this.state.allPageJson.static_text_eChannelReporting !== undefined
                      ? <EchannelReporting
                          data={this.state.data}
                          echannels={this.state.originalData}
                          pageJson={this.state.allPageJson.static_text_eChannelReporting}
                          translations={(word) => this.translations(word)}
                          countryList= {this.props.countryList}
                          getCountryTaxonomy={(item) => this.getCountryTaxonomy(item)}
                        />
                      : null
                    }

                    <hr/>
                    {
                      this.state.allPageJson !== undefined && this.state.allPageJson.staticText_accountInterestLimits !== undefined && this.state.allPageJson.staticText_previewBalance !== undefined && this.state.allPageJson.staticText_previewAccountInterestLimits !== undefined
                      ? [
                          <AccountInterestLimit
                            data={this.state.data}
                            pageJson={this.state.allPageJson.staticText_accountInterestLimits}
                            pageJsonOth={this.state.allPageJson.staticText_previewBalance}
                            pageJsonOth1={this.state.allPageJson.staticText_previewAccountInterestLimits}
                            translations={(word) => this.translations(word)}
                            translateWordForOption={(word) => this.translateWordForOption(word)}
                            newAccounts={this.props.newAccounts}
                            accountCountryList= {this.props.accountCountryList}
                            getCountryTaxonomy={(item) => this.getProductRelatedTaxonomy(item)}
                          />,
                          <hr/>
                        ]
                      : ''
                    }
                    {
                      this.state.allPageJson !== undefined && this.state.allPageJson.staticText_previewSweepGroupLimits !== undefined
                      ? [
                          <SweepGroupLimit
                            data={this.state.data}
                            pageJson={this.state.allPageJson.staticText_previewSweepGroupLimits}
                            translations={(word) => this.translations(word)}
                            translateWordForOption={(word) => this.translateWordForOption(word)}
                            accountCountryList= {this.props.accountCountryList}
                            getCountryTaxonomy={(item) => this.getProductRelatedTaxonomy(item)}
                          />,
                          <hr/>
                        ]
                      : ''
                    }
                    {
                      this.state.allPageJson !== undefined && this.state.allPageJson.staticText_previewOrderSweepExecution !== undefined
                      ? <SweepExecution
                          data={this.state.data}
                          pageJson={this.state.allPageJson.staticText_previewOrderSweepExecution}
                          translations={(word) => this.translations(word)}
                          translateWordForOption={(word) => this.translateWordForOption(word)}
                          accountCountryList= {this.props.accountCountryList}
                          getCountryTaxonomy={(item) => this.getProductRelatedTaxonomy(item)}
                        />
                      : ''
                    }
                  </NavListAccordion>
                </NavListAccordionWrapper>
              </div>
              <div className="gdoc-supportdoc-footer-btn ie-footer-button">
                <button
                  onClick={() => this.eventToGoCase()}
                  className="gdocs-btn-primary case-history-btn"
                  name="supportingDoc"
                >
                  {
                    this.state.allPageJson !== undefined && this.state.allPageJson.staticText_previewData !== undefined
                    ? this.translations(this.state.allPageJson.staticText_previewData.exitPreview)
                    : 'Exit Preview'
                  }
                </button>
              </div>
            </div>
          </div>
        )
      }else {
        return null;
      }
    }
}


PreviewCashCon.propTypes = {
  data: PropTypes.object
};

const mapStateToProps = state => {
  return {
    lang: state.lang
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setLandingActiveTab: (activeTabId) => {
      dispatch(setLandingActiveTab(activeTabId));
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PreviewCashCon);



// WEBPACK FOOTER //
// ./src/components/CaseList/PreviewGLS/CCPreview/PreviewCashCon.js